import { nonEmptyStringValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { recaptchaV2SizeValidator } from './size';
export const recaptchaV2ConfigValidator = Validator.object({
    siteKey: nonEmptyStringValidator,
    size: Validator.optional(recaptchaV2SizeValidator)
});
//# sourceMappingURL=config.js.map